import { useContext } from 'react';
import { WorkflowEngineContext } from '../../WorkflowEngine/workflowEngineReducer';
import { Stack, Grid } from '@mui/material';
import FormEntryView from '../FormEntryView';
import CompletionScreen from '../CompletionScreen';

export default () => {
  const { state } = useContext(WorkflowEngineContext);

  const { isWorkflowCompleted } = state;

  return (
    <Stack>
      <Grid container spacing={3}>
        {isWorkflowCompleted ? <CompletionScreen /> : <FormEntryView />}
      </Grid>
    </Stack>
  );
};
